import React, { useEffect, useState } from "react";
import {
  DEFAULT_ORDER_PICKUP_TIME,
  MAX_ORDER_PICKUP_DAY,
  VERTICALS
} from "../../utils/constants";
import { add } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { pDateFormat, yyyyMMdd } from "../../utils/helper";
import { toast } from "react-toastify";

const RescheduleOrder = props => {
  const {
    orderDetail,
    rescheduleOrder,
    closeModal,
    getOrderTimeSlots,
    resetOrderTimeSlotsState,
    orderTimeSlots,
    vertical,
    rescheduleStrings,
    isScheduleFromBooked = false,
    homeCareCategories = [],
    xRayCategories = []
  } = props;
  const [rescheduleDate, setRescheduleDate] = useState(
    add(new Date(), { minutes: DEFAULT_ORDER_PICKUP_TIME })
  );
  const [orderTimeSlot, setOrderTimeSlot] = useState("");

  const [reason, setReason] = useState("");
  const [rescheduleStringId, setRescheduleStringId] = useState("");
  const [homeCareCategoryId, setHomeCareCategoryId] = useState(
    orderDetail?.homeCareCategory?.id || ""
  );
  const [xRayCategoryId, setXRayCategoryId] = useState(
    orderDetail?.xRayCategory?.id || ""
  );
  const [requiresFemaleStaff, setRequiresFemaleStaff] = useState(
    !!(
      orderDetail?.requiresFemaleStaff || orderDetail?.requires_female_staff
    )
  );
  const [estimatedTime, setEstimatedTime] = useState(
    orderDetail?.estimatedTime || ""
  );
  const [hasAllergy, setHasAllergy] = useState(
    !!orderDetail?.patient?.hasAllergy
  );
  const [allergies, setAllergies] = useState(
    orderDetail?.patient?.allergies || ""
  );

  useEffect(() => {
    if (rescheduleStrings.length > 0) {
      setRescheduleStringId(rescheduleStrings[0].id);
    }
  }, rescheduleStrings);

  useEffect(() => {
    setHomeCareCategoryId(orderDetail?.homeCareCategory?.id || "");
  }, [orderDetail?.id, orderDetail?.homeCareCategory?.id]);

  useEffect(() => {
    setXRayCategoryId(orderDetail?.xRayCategory?.id || "");
  }, [orderDetail?.id, orderDetail?.xRayCategory?.id]);

  useEffect(() => {
    setRequiresFemaleStaff(
      !!(
        orderDetail?.requiresFemaleStaff || orderDetail?.requires_female_staff
      )
    );
  }, [
    orderDetail?.id,
    orderDetail?.requiresFemaleStaff,
    orderDetail?.requires_female_staff
  ]);

  useEffect(() => {
    setEstimatedTime(orderDetail?.estimatedTime || "");
  }, [orderDetail?.id, orderDetail?.estimatedTime]);

  useEffect(() => {
    setHasAllergy(!!orderDetail?.patient?.hasAllergy);
    setAllergies(orderDetail?.patient?.allergies || "");
  }, [
    orderDetail?.id,
    orderDetail?.patient?.hasAllergy,
    orderDetail?.patient?.allergies
  ]);

  useEffect(() => {
    return () => {
      setOrderTimeSlot("");
      resetOrderTimeSlotsState();
    };
  }, []);

  useEffect(() => {
    if (!rescheduleDate || !orderDetail.region) {
      return;
    }
    setOrderTimeSlot("");
    resetOrderTimeSlotsState();
    getOrderTimeSlots({
      date: yyyyMMdd(rescheduleDate),
      regionId: orderDetail.region,
      isCovid: (orderDetail.scanTypes || []).some(
        item => item.scanType?.isCovid
      ),
      vertical,
      orderId: orderDetail.id,
      customerAddressId: orderDetail.customerAddress?.id
    });
  }, [rescheduleDate, orderDetail.region]);

  const onRescheduleOrder = e => {
    e.preventDefault();
    if (vertical === VERTICALS.homecare && !homeCareCategoryId) {
      toast.error("Select home care category");
      return;
    }
    if (vertical === VERTICALS.xray && !xRayCategoryId) {
      toast.error("Select X-ray category");
      return;
    }
    if (!orderTimeSlot) {
      toast.error(isScheduleFromBooked ? "Select schedule time" : "Select re-schedule time");
      return;
    }
    const timeSlot = orderTimeSlots.find(ots => ots.id == orderTimeSlot);
    if (!timeSlot) {
      setOrderTimeSlot("");
      return;
    }
    rescheduleOrder({
      id: orderDetail.id,
      vertical,
      previousState: orderDetail.state,
      data: {
        date: yyyyMMdd(timeSlot.dateTime),
        timeSlot: timeSlot.id,
        reason,
        rescheduleStringId,
        ...(vertical === VERTICALS.homecare && homeCareCategoryId
          ? { homeCareCategory: +homeCareCategoryId }
          : {}),
        ...(vertical === VERTICALS.homecare
          ? { requiresFemaleStaff }
          : {}),
        ...(vertical === VERTICALS.xray && xRayCategoryId
          ? { xRayCategory: +xRayCategoryId }
          : {}),
        estimatedTime,
        hasAllergy,
        allergies: hasAllergy ? allergies : ""
      }
    });
    closeModal();
  };
  return (
    <div className="lightbox lightbox-order-top re-assign">
      <div className="lightbox-head">
        <a
          href=""
          className="lightbox-close icon-clear"
          onClick={e => {
            e.preventDefault();
            closeModal();
          }}
        />
        <h3>{isScheduleFromBooked ? "Schedule Order" : "Re-Schedule Order"}</h3>
      </div>
      <div className="cl-holder">
        <div className="datepick">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              disableToolbar
              variant="static"
              minDate={new Date()}
              disablePast
              maxDate={add(new Date(), { days: MAX_ORDER_PICKUP_DAY })}
              onChange={val => {
                setRescheduleDate(val);
              }}
              name="pickup"
              value={rescheduleDate}
              format="yyyy/MM/dd"
              placeholder="DD/MM/YYYY"
            />
          </MuiPickersUtilsProvider>
          <div className="reschedule-reason">
            {vertical === VERTICALS.homecare && (
              <>
                <div className="form-row">
                  <select
                    value={homeCareCategoryId}
                    onChange={e => {
                      setHomeCareCategoryId(e.target.value);
                    }}
                  >
                    <option value="">Select home care category</option>
                    {homeCareCategories.map(category => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-row">
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={requiresFemaleStaff}
                      onChange={e => setRequiresFemaleStaff(e.target.checked)}
                    />
                    <span className="fake-checkbox" />
                    <span className="text">Female staff required</span>
                  </label>
                </div>
              </>
            )}
            {vertical === VERTICALS.xray && (
              <div className="form-row">
                <select
                  value={xRayCategoryId}
                  onChange={e => {
                    setXRayCategoryId(e.target.value);
                  }}
                >
                  <option value="">Select X-ray category</option>
                  {xRayCategories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="form-row">
              <select
                value={rescheduleStringId || ""}
                onChange={e => {
                  setRescheduleStringId(e.target.value);
                }}
              >
                {rescheduleStrings.map(i => (
                  <option key={i.id} value={i.id}>
                    {i.text}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-row">
              <textarea
                placeholder=""
                value={reason}
                onChange={e => setReason(e.target.value)}
              />
            </div>
            <div className="form-row">
              <label>Estimated Time/Period</label>
              <input
                type="text"
                placeholder="e.g. 2 hours, 30 mins"
                value={estimatedTime}
                onChange={e => setEstimatedTime(e.target.value)}
              />
            </div>
            <div className="form-row">
              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  checked={hasAllergy}
                  onChange={e => {
                    setHasAllergy(e.target.checked);
                    if (!e.target.checked) {
                      setAllergies("");
                    }
                  }}
                />
                <span className="fake-checkbox" />
                <span className="text">Allergy</span>
              </label>
            </div>
            {hasAllergy && (
              <div className="form-row">
                <label>Patient Allergies</label>
                <textarea
                  placeholder="List the patient's allergies"
                  value={allergies}
                  onChange={e => setAllergies(e.target.value)}
                />
              </div>
            )}
          </div>
        </div>
        <div className="time-slot">
          <span className="title"> Available Time</span>
          <ul className="time-list">
            {orderTimeSlots.map(timeSlot => {
              return (
                <li
                  key={timeSlot.dateTime.toISOString()}
                  className={`${timeSlot.id === orderTimeSlot ? "active" : ""}`}
                  onClick={e => {
                    e.preventDefault();
                    setOrderTimeSlot(timeSlot.id);
                  }}
                >
                  {pDateFormat(timeSlot.dateTime)}
                </li>
              );
            })}
          </ul>
          <a
            href=""
            className="assigner-create-btn"
            onClick={onRescheduleOrder}
          >
            {isScheduleFromBooked ? "Schedule Order" : "Re-schedule Order"}
          </a>
        </div>
      </div>
    </div>
  );
};

export default RescheduleOrder;
